import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GivebutterRegular from './givebutter-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GivebutterRegular {...validProps} />;
}
SvgComponent.iconName = 'givebutterRegular';

export const GivebutterRegularIcon = svgIconWrapper(SvgComponent);
